import { HTTP } from '@/services/axios';

export async function getCityOptions(){
    let result = {};

    await HTTP({
        method: 'get',
        url: '/app/core/Common/getCityOptions.php',
     })
    .then(response => {
        result = response.data;  
    })
    .catch(function (error) {
        result={'status':error.response.status,'statusText':error.response.statusText}
    });

    return result;
}

export async function getRegionOptions(){
    let result = {};

    await HTTP({
        method: 'get',
        url: '/app/core/Common/getRegionOptions.php',
    })
    .then(response => {
        result = response.data;  
    })
    .catch(function (error) {
        result={'status':error.response.status,'statusText':error.response.statusText}
    });

    return result;
}

export async function getCountryOptions(){
    let result = {};

    await HTTP({
        method: 'get',
        url: '/app/core/Common/getCountryOptions.php',
    })
    .then(response => {
        result = response.data;  
    })
    .catch(function (error) {
        result={'status':error.response.status,'statusText':error.response.statusText}
    });

    return result;
}

export async function getDistrictsOptions(){
    let result = {};

    await HTTP({
        method: 'get',
        url: '/app/core/Common/getDistrictsOptions.php',
    })
    .then(response => {
        result = response.data;  
    })
    .catch(function (error) {
        result={'status':error.response.status,'statusText':error.response.statusText}
    });

    return result;
}
